<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner"></div>
</div>

<!-- loading.component.html -->
<!-- <div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner"></div>
  <div class="progress-container">
    <div class="progress-bar" [style.width.%]="progress"></div>
    <span class="progress-text">{{ progress }}%</span>
  </div>
</div> -->
